import { gql } from '../../../__generated__/graphql/catalog'

export const FETCH_CART_VARIANTS = gql(`
  query GetCartVariants($skus: [String!]) {
    productCatalogVariants(skus: $skus) {
      __typename
      id
      sku
      shopifyId
      shopifyProductId
      availability
      stockState
      urlPath
      price {
        amount
        currencyCode
      }
      compareAtPrice {
        amount
      }
      images(first: 1) {
        url
      }
      fit {
        id
        displayValue
      }
      size {
        id
        displayValue
      }
      group {
        __typename
        id
        title
        finalSale
        primaryCategory {
          key
          analyticsId
          displayValue
        }
        siteWidePromoEligible
        exclusive
        gender
        color {
          id
          displayValue
        }
        product {
          __typename
          id
          handle
        }
      }
    }
  }
`)
